export default "__VITE_ASSET__CV6jYg4F__"